<template>
  <footer
    class="tw-border-2 tw-border-t-primary tw-bg-[#f8f8f8] tw-flex tw-items-center tw-px-10 tw-py-4 tw-text-xs xl:tw-pl-24"
    role="contentinfo"
  >
    <div class="tw-hidden xl:tw-inline-flex xl:tw-flex-grow">
      <ul
        v-for="(groupOfLinks, index) in desktopLinksGrouped"
        :key="index"
        class="tw-mr-7 tw-space-y-2"
      >
        <li v-for="(link, linkIndex) in groupOfLinks" :key="linkIndex">
          <NuxtOrExternalLink
            class="tw-text-[#4164e3]"
            :href="link.href"
            :to="link.to"
            @click.native="onClickItem(link)"
          >
            {{ link.title }}
          </NuxtOrExternalLink>
        </li>
      </ul>
    </div>

    <div
      class="tw-flex tw-flex-grow xl:tw-flex-shrink tw-flex-col lg:tw-flex-row"
    >
      <div class="tw-flex-grow xl:tw-flex-shrink xl:tw-pr-10 xl:tw-text-right">
        <h1 class="tw-text-sm tw-my-2">{{ $t('footer__group_1') }}</h1>
        <ul class="tw-space-y-2">
          <li v-for="(link, index) in globalLinks" :key="index">
            <a class="tw-text-[#4164e3]" :href="link.href">
              {{ link.title }}
            </a>
          </li>
        </ul>
      </div>

      <div
        class="tw-flex-grow xl:tw-flex-shrink xl:tw-pr-10 xl:tw-text-right tw-mt-2 lg:tw-mt-0"
      >
        <h1 class="tw-text-sm tw-my-2">
          <h1 class="tw-text-sm tw-my-2">{{ $t('footer__group_2') }}</h1>
        </h1>
        <ul class="tw-space-y-2">
          <li v-for="(link, index) in usioLinks" :key="index">
            <a class="tw-text-[#4164e3]" :href="link.href">
              {{ link.title }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="tw-flex-initial tw-w-[100px]">
      <img
        class="tw-object-contain"
        src="/logo.png"
        alt="UpTogether Logo"
        title="UpTogether Logo"
      />
      <div class="tw-flex tw-justify-around">
        <a
          v-for="(link, index) in socialLinks"
          :key="index"
          :href="link.href"
          :title="link.title"
          class="tw-text-black tw-text-base"
          target="_blank"
        >
          <component :is="link.icon" />
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import _ from 'lodash'
import IconFacebook from 'vue-material-design-icons/Facebook'
import IconInstagram from 'vue-material-design-icons/Instagram'
import IconLinkedin from 'vue-material-design-icons/Linkedin'
import IconTwitter from 'vue-material-design-icons/Twitter'
import NuxtOrExternalLink from '@/components/shared/NuxtOrExternalLink'
import PermisionsMixin from '@/components/shared/PermisionsMixin'
import NavigationItemMixin from '@/components/shared/NavigationItemMixin'

export default {
  components: {
    IconFacebook,
    IconInstagram,
    IconLinkedin,
    IconTwitter,
    NuxtOrExternalLink,
  },
  mixins: [PermisionsMixin, NavigationItemMixin],
  data() {
    return {
      desktopLinks: [
        {
          title: this.$t('navigation__home'),
          to: this.localePath('/'),
        },
        {
          title: this.$tc('navigation__group', 2),
          href: process.env.COMMUNITY_SITE_URL,
          permissions: ['app_social'],
          analytics: {
            event: 'social__community_site',
            args: (item) => ({ site: item.href }),
          },
        },
        {
          title: this.$t('navigation__financials'),
          to: this.localePath('financials'),
          permissions: ['app_financials'],
        },
        {
          title: this.$tc('navigation__survey', 2),
          to: this.localePath('surveys'),
          permissions: ['app_surveys'],
        },
        {
          title: this.$t('navigation__help_center'),
          href: `https://support.uptogether.org/${this.localePath('/')}`,
        },
        {
          title: this.$t('navigation__support'),
          href: 'https://support.uptogether.org/',
        },
        {
          title: this.$t('navigation__contact'),
          href: 'https://www.uptogether.org/contact/',
        },
        {
          title: this.$t('navigation__settings'),
          to: this.localePath('settings'),
        },
      ],
      globalLinks: [
        {
          title: this.$t('footer__tos'),
          href: 'https://www.uptogether.org/terms-of-use/',
        },
        {
          title: this.$t('footer__privacy'),
          href: 'https://www.uptogether.org/privacy-policy/',
        },
        {
          title: this.$t('footer__coc'),
          href: 'https://www.uptogether.org/code-of-conduct/',
        },
        {
          title: this.$t('language_assistance'),
          href: this.$t('language_assistance_url'),
        },
        {
          title: this.$t('illustration_made'),
          href: 'https://storyset.com/',
        },
      ],
      usioLinks: [
        {
          title: this.$t('footer__wallet_e_sign_disclosure'),
          href: this.$t('usio_link_e_sign_disclosure'),
        },
        {
          title: this.$t('footer__wallet_privacy_policy'),
          href: this.$t('usio_link_privacy_policy'),
        },
        {
          title: this.$t('footer__wallet_akimbo_cardholder_agreement'),
          href: this.$t('usio_link_akimbo_cardholder_agreement'),
        },
        {
          title: this.$t('footer__wallet_uptogether_cardholder_agreement'),
          href: this.$t('usio_link_cardholder_agreement'),
        },
        {
          title: '1-855-449-2273',
          href: 'tel:+18554492273',
        },
      ],
      socialLinks: [
        {
          href: 'https://www.facebook.com/move_uptogether/"',
          icon: IconFacebook,
          title: 'Facebook',
        },
        {
          href: 'https://twitter.com/move_uptogether/"',
          icon: IconTwitter,
          title: 'Twitter',
        },
        {
          href: 'https://www.linkedin.com/company/move-uptogether',
          icon: IconLinkedin,
          title: 'Linkedin',
        },
        {
          href: 'https://www.instagram.com/move_uptogether/"',
          icon: IconInstagram,
          title: 'Instagram',
        },
      ],
    }
  },
  computed: {
    desktopLinksGrouped() {
      return _.chunk(this.filteredLinks, 3)
    },
    filteredLinks() {
      return this.desktopLinks.filter((page) =>
        this.hasPermisionAndFeature(page)
      )
    },
  },
  methods: {
    onClickItem(item) {
      this.sendEventFromAnalyticsDefs(item)
    },
  },
}
</script>
